import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Button from "./button"

const StyledButton = styled(Button)`
  background: transparent;
  border: 1px solid #222a3f;
  color: #222a3f;
  transition: all 400ms;

  &:hover,
  &:focus {
    background-color: #222a3f;
    color: #fff;
  }
`

const OutlineButton = ({
  children = null,
  to = null,
  id = null,
  className = null,
  ariaLabel = null,
}) => {
  return (
    <StyledButton to={to} className={className} id={id} ariaLabel={ariaLabel}>
      {children}
    </StyledButton>
  )
}

OutlineButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  to: PropTypes.string,
  id: PropTypes.string,
  ariaLabel: PropTypes.string,
}

export default OutlineButton
